// extracted by mini-css-extract-plugin
export var container = "_fr-1";
export var editor = "_fr-2";
export var resizable = "_fr-3";
export var wrapper = "_fr-0";